/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmChatopsAndVideoToolsType from '@jira/spa-apps__admin-pages-products-jsm-chatops-and-video-tools/src/ProductsJsmChatopsAndVideoToolsType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmChatopsAndVideoTools: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProductsJsmChatopsAndVideoToolsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-products-jsm-chatops-and-video-tools", jiraSpaEntry: "async-products-jsm-chatops-and-video-tools" */ '@jira/spa-apps__admin-pages-products-jsm-chatops-and-video-tools/src/ProductsJsmChatopsAndVideoToolsType.tsx'
			),
		),
	);

const AsyncProductsJsmChatopsAndVideoTools = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmChatopsAndVideoTools}
		pageId="products-jsm-chatops-and-video-tools"
		shouldShowSpinner={false}
	/>
);

export default AsyncProductsJsmChatopsAndVideoTools;
